.email-outreach-container > * {
    /* Without this spacing, the text bumps against the bottom of the modal */
    margin-top: -28px;
}

.get-started-icon-container > * {
    display: flex;
}
